module.exports = __webpack_public_path__ + "static/img/screw_256.b5dc0f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screw_256.png
// module id = CTyl
// module chunks = 0